export default __webpack_public_path__ + "static/media/photo-cv.48ae1518.jpg";